<template>
  <vs-table :data="data" :noDataText="$t('no_data_available')">
    <template slot="thead">
      <vs-th width="50%" class="text-left xs:visible hidden">
        {{ $t('company') }}<br />
        {{ $t('serie') }} | {{ $t('folio') }}<br />
        {{ $t('received_date') }} | {{ $t('pay_day') }}<br />
        {{ $t('method') }} | {{ $t('reference') }} |<br />
        {{ $t('currency') }}<br />
        {{ $t('comment') }}
      </vs-th>
      <vs-th width="60px" class="text-center xs:visible hidden">{{
        $t('status')
      }}</vs-th>
      <vs-th width="60px" class="text-center xs:visible hidden"></vs-th>
      <vs-th width="350px" class="text-center xs:hidden">{{
        $t('company')
      }}</vs-th>
      <vs-th width="200px" class="text-center xs:hidden">
        {{ $t('serie') | capitalize }} | {{ $t('folio') | capitalize }}
      </vs-th>
      <vs-th width="150px" class="text-center xs:hidden">{{
        $t('received_date')
      }}</vs-th>
      <vs-th width="150px" class="text-center xs:hidden">{{
        $t('pay_day')
      }}</vs-th>
      <vs-th width="80px" class="text-center xs:hidden">{{
        $t('currency')
      }}</vs-th>
      <vs-th width="300px" class="text-center xs:hidden"
        >{{ $t('method') }} | {{ $t('reference') }}</vs-th
      >
      <vs-th width="100px" class="text-center xs:hidden">{{
        $t('status')
      }}</vs-th>
      <vs-th width="300px" class="text-center xs:hidden">{{
        $t('comment')
      }}</vs-th>
      <vs-th width="20px" class="text-center xs:hidden"></vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <!-- MOBILE -->
        <vs-td width="50%" class="xs:visible hidden">
          {{ data[i].company_name }}<br />
          {{  data[i].serie !== null && data[i].serie !== '' ? ` ${data[i].serie} | ` : '' }}{{ data[i].folio }}<br />
          {{ formatDate(data[i].received_date, 'MMM - DD') | capitalize }} |
          {{ data[i].pay_date !== null ? formatDate(data[i].pay_date, 'DD/MM/YYYY') : '' }}<br />
          {{
            data[i].payment_method !== null
              ? `${$t(data[i].payment_method.toLowerCase())} |`
              : ''
          }}
          {{ data[i].policy }} | {{ data[i].currency }}<br />
          <span style="color: red; text-transform: lowercase">{{
            data[i].comments
          }}</span>
        </vs-td>
        <vs-td class="text-left text-bold xs:visible hidden" width="60px">
          <vs-chip transparent :color="data[i].status_color">
            {{ getStatusName(data[i].status_id) }}
          </vs-chip>
        </vs-td>
        <vs-td class="text-left text-bold xs:visible hidden">
          <action-icon
              icon="UploadIcon"
              tooltip="Subir Archivo"
              @click="handleUploadClick(data[i].expense_id)"
            />
        </vs-td>
        <!-- DESKTOP -->
        <vs-td class="xs:hidden">
          {{ data[i].company_name }}
        </vs-td>

        <vs-td class="xs:hidden">
          {{   data[i].serie !== null && data[i].serie !== '' ? ` ${data[i].serie} | ` : '' }}{{ data[i].folio }}
        </vs-td>

        <vs-td class="xs:hidden">
          {{ formatDate(data[i].received_date, 'MMM - DD') | capitalize }}
        </vs-td>

        <vs-td class="xs:hidden">
         {{(data[i].pay_date !== null && data[i].status_id >= 2) ? formatDate(data[i].pay_date, 'DD/MM/YYYY') : ''}}
        </vs-td>

        <vs-td class="xs:hidden">
          {{ data[i].currency }}
        </vs-td>

        <vs-td class="xs:hidden">
          {{
            data[i].payment_method !== null
              ? `${$t(data[i].payment_method.toLowerCase())}`
              : ''
          | capitalize }}

          {{   data[i].payment_policy !== null ? `| ${data[i].payment_policy}` : '' }}
        </vs-td>

        <vs-td class="xs:hidden text-left text-bold">
          <vs-chip transparent :color="data[i].status_color">
            {{ getStatusName(data[i].status_id) }}
          </vs-chip>
          <!-- <span :style="{color:data[i].color}"></span> -->
        </vs-td>
        <vs-td class="xs:hidden">
          <span >{{ data[i].comments }}</span>
        </vs-td>

        <vs-td class="xs:hidden">
          <action-icon
              icon="UploadIcon"
              tooltip="Subir Archivo"
              @click="handleUploadClick(data[i].expense_id)"
            />
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>

    </template>
  </vs-table>
</template>

<script>
import mixins from '@/mixins.js'
import defaultStatusList from './defaultStatusList.js'
import ActionIcon from '@/components/ActionIcon.vue'

export default {
  mixins: [mixins],
  components:{
    ActionIcon
  },
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    getStatusName(id) {
      let status = defaultStatusList.find((el) => el.id === id)
      return status.label
    },
    handleUploadClick(expenseId){
      this.$emit('uploadClick',expenseId)
    }
  },
}
</script>

<style>
.text-bold {
  font-weight: bold;
}
.montserrat-font {
  font-family: 'Montserrat';
}
@media (max-width: 576px) {
  .xs\:hidden {
    display: none !important;
  }
  .xs\:visible {
    display: revert !important;
  }
}
</style>
